// Hobbies & known conditions cards — extracted from pages/Settings.jsx.
import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Badge } from '../ui/badge';
import { Heart, Plus, X } from 'lucide-react';

export function HobbiesConditionsCards({ t, language, profileForm, setProfileForm }) {
    const [newHobby, setNewHobby] = useState('');
    const [newCondition, setNewCondition] = useState('');

    const addHobby = () => {
        if (newHobby.trim() && !profileForm.hobbies.includes(newHobby.trim())) {
            setProfileForm({ ...profileForm, hobbies: [...profileForm.hobbies, newHobby.trim()] });
            setNewHobby('');
        }
    };

    const removeHobby = (hobby) => {
        setProfileForm({ ...profileForm, hobbies: profileForm.hobbies.filter(h => h !== hobby) });
    };

    const addCondition = () => {
        if (newCondition.trim() && !profileForm.known_conditions.includes(newCondition.trim())) {
            setProfileForm({ ...profileForm, known_conditions: [...profileForm.known_conditions, newCondition.trim()] });
            setNewCondition('');
        }
    };

    const removeCondition = (condition) => {
        setProfileForm({ ...profileForm, known_conditions: profileForm.known_conditions.filter(c => c !== condition) });
    };

    return (
        <>
                {/* Hobbies */}
                <Card>
                    <CardHeader>
                        <CardTitle className="text-lg">
                            {language === 'de' ? 'Hobbys & Interessen' : 'Hobbies & Interests'}
                        </CardTitle>
                        <CardDescription>
                            {language === 'de' 
                                ? 'Hilft dem AI Coach, personalisierte Empfehlungen zu geben'
                                : 'Helps the AI Coach give personalized recommendations'}
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <div className="flex flex-wrap gap-2">
                            {profileForm.hobbies.map((hobby) => (
                                <Badge key={hobby} variant="secondary" className="gap-1 pr-1">
                                    {hobby}
                                    <Button
                                        variant="ghost"
                                        size="icon"
                                        className="h-4 w-4 hover:bg-transparent"
                                        onClick={() => removeHobby(hobby)}
                                    >
                                        <X className="w-3 h-3" />
                                    </Button>
                                </Badge>
                            ))}
                        </div>
                        <div className="flex gap-2">
                            <Input
                                value={newHobby}
                                onChange={(e) => setNewHobby(e.target.value)}
                                onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), addHobby())}
                                placeholder={language === 'de' ? 'z.B. Yoga, Wandern, Kochen...' : 'e.g. Yoga, Hiking, Cooking...'}
                                className="flex-1"
                            />
                            <Button onClick={addHobby} size="icon" variant="outline">
                                <Plus className="w-4 h-4" />
                            </Button>
                        </div>
                    </CardContent>
                </Card>

                {/* Known Conditions */}
                <Card>
                    <CardHeader>
                        <CardTitle className="text-lg flex items-center gap-2">
                            <Heart className="w-5 h-5 text-rose-500" />
                            {language === 'de' ? 'Bekannte Beschwerden' : 'Known Conditions'}
                        </CardTitle>
                        <CardDescription>
                            {language === 'de' 
                                ? 'Gesundheitliche Themen, die bei Empfehlungen berücksichtigt werden sollen'
                                : 'Health topics to consider in recommendations'}
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <div className="flex flex-wrap gap-2">
                            {profileForm.known_conditions.map((condition) => (
                                <Badge key={condition} variant="outline" className="gap-1 pr-1 border-rose-200 bg-rose-50 dark:bg-rose-900/20">
                                    {condition}
                                    <Button
                                        variant="ghost"
                                        size="icon"
                                        className="h-4 w-4 hover:bg-transparent"
                                        onClick={() => removeCondition(condition)}
                                    >
                                        <X className="w-3 h-3" />
                                    </Button>
                                </Badge>
                            ))}
                        </div>
                        <div className="flex gap-2">
                            <Input
                                value={newCondition}
                                onChange={(e) => setNewCondition(e.target.value)}
                                onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), addCondition())}
                                placeholder={language === 'de' ? 'z.B. Migräne, Rückenschmerzen, Allergien...' : 'e.g. Migraines, Back pain, Allergies...'}
                                className="flex-1"
                            />
                            <Button onClick={addCondition} size="icon" variant="outline">
                                <Plus className="w-4 h-4" />
                            </Button>
                        </div>
                    </CardContent>
                </Card>

        </>
    );
}
